import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { HomeModule } from './home/home.module';
import { SegmentosModule } from './segmentos/segmentos.module';
import { CasesModule } from './cases/cases.module';
import { PlataformaModule } from './plataforma/plataforma.module';
import { RevendaModule } from './revenda/revenda.module';
import { ContatoModule } from './contato/contato.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,

        HomeModule,
        SegmentosModule,
        CasesModule,
        PlataformaModule,
        RevendaModule,
        ContatoModule
    ]
})

export class MainModule { }
